import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';

export interface IVHSIconSamplesProps extends IBaseElementProps {}

const VHSIconSamples: React.FC<IVHSIconSamplesProps> = ({
	className,
	classNames = [],
}) => (
	<div className={className || cn('vhs-icon-samples', ...classNames)}>
		<div className="container-narrow my-5">
			<div className="row">
				<div className="col-12">
					<h2 className="text-center">Icons</h2>
					<div className="container-fluid text-center my-5">
						<div className="row my-5">
							<p className="lead">
								Arrow Left (classname: icon-arrow-left):{' '}
								<span className="icon icon-arrow-left"></span>
							</p>
							<p className="lead">
								Arrow Right (classname: icon-arrow-right):{' '}
								<span className="icon icon-arrow-right"></span>
							</p>
							<p className="lead">
								Bag (classname: icon-bag):{' '}
								<span className="icon icon-bag"></span>
							</p>
							<p className="lead">
								Bell (classname: icon-bell):{' '}
								<span className="icon icon-bell"></span>
							</p>
							<p className="lead">
								Book (classname: icon-book):{' '}
								<span className="icon icon-book"></span>
							</p>
							<p className="lead">
								Brain (classname: icon-brain):{' '}
								<span className="icon icon-brain"></span>
							</p>
							<p className="lead">
								Broadcast (classname: icon-broadcast):{' '}
								<span className="icon icon-broadcast"></span>
							</p>
							<p className="lead">
								Bulb (classname: icon-bulb):{' '}
								<span className="icon icon-bulb"></span>
							</p>
							<p className="lead">
								Calendar (classname: icon-calendar):{' '}
								<span className="icon icon-calendar"></span>
							</p>
							<p className="lead">
								Call (classname: icon-call):{' '}
								<span className="icon icon-call"></span>
							</p>
							<p className="lead">
								Calculator (classname: icon-calculator):{' '}
								<span className="icon icon-calculator"></span>
							</p>
							<p className="lead">
								Canada (classname: icon-canada):{' '}
								<span className="icon icon-canada"></span>
							</p>
							<p className="lead">
								Cardholder (classname: icon-cardholder):{' '}
								<span className="icon icon-cardholder"></span>
							</p>
							<p className="lead">
								Caret Down (classname: icon-caret-down):{' '}
								<span className="icon icon-caret-down"></span>
							</p>
							<p className="lead">
								Caret Left Slim (classname: icon-caret-left-slim):{' '}
								<span className="icon icon-caret-left-slim"></span>
							</p>
							<p className="lead">
								Caret Right (classname: icon-caret-right):{' '}
								<span className="icon icon-caret-right"></span>
							</p>
							<p className="lead">
								Caret Right Slim (classname: icon-caret-right-slim):{' '}
								<span className="icon icon-caret-right-slim"></span>
							</p>
							<p className="lead">
								Caret Up (classname: icon-caret-up):{' '}
								<span className="icon icon-caret-up"></span>
							</p>
							<p className="lead">
								Chat (classname: icon-chat):{' '}
								<span className="icon icon-chat"></span>
							</p>
							<p className="lead">
								Checkmark (classname: icon-checkmark):{' '}
								<span className="icon icon-checkmark"></span>
							</p>
							<p className="lead">
								Clock (classname: icon-clock):{' '}
								<span className="icon icon-clock"></span>
							</p>
							<p className="lead">
								Close (classname: icon-close):{' '}
								<span className="icon icon-close"></span>
							</p>
							<p className="lead">
								Course (classname: icon-course):{' '}
								<span className="icon icon-course"></span>
							</p>
							<p className="lead">
								Double Caret Left Slim (classname: icon-double-caret-left-slim):{' '}
								<span className="icon icon-double-caret-left-slim"></span>
							</p>
							<p className="lead">
								Double Caret Right Slim (classname: icon-double-caret-right-slim):{' '}
								<span className="icon icon-double-caret-right-slim"></span>
							</p>
							<p className="lead">
								Email (classname: icon-email):{' '}
								<span className="icon icon-email"></span>
							</p>
							<p className="lead">
								Facebook (classname: icon-caret-down):{' '}
								<span className="icon icon-facebook"></span>
							</p>
							<p className="lead">
								Fast Track (classname: icon-fast-track):{' '}
								<span className="icon icon-fast-track"></span>
							</p>
							<p className="lead">
								Info (classname: icon-info):{' '}
								<span className="icon icon-info"></span>
							</p>
							<p className="lead">
								Instagram (classname: icon-instagram):{' '}
								<span className="icon icon-instagram"></span>
							</p>
							<p className="lead">
								International (classname: icon-international):{' '}
								<span className="icon icon-international"></span>
							</p>
							<p className="lead">
								Magnifying Glass (classname: icon-magnifying-glass):{' '}
								<span className="icon icon-magnifying-glass"></span>
							</p>
							<p className="lead">
								Menu (classname: icon-menu):{' '}
								<span className="icon icon-menu"></span>
							</p>
							<p className="lead">
								Minus (classname: icon-minus):{' '}
								<span className="icon icon-minus"></span>
							</p>
							<p className="lead">
								Pencil (classname: icon-pencil):{' '}
								<span className="icon icon-pencil"></span>
							</p>
							<p className="lead">
								Plus (classname: icon-plus):{' '}
								<span className="icon icon-plus"></span>
							</p>
							<p className="lead">
								Prerequisite (classname: icon-prerequisite):{' '}
								<span className="icon icon-prerequisite"></span>
							</p>
							<p className="lead">
								Purchases (classname: icon-purchases):{' '}
								<span className="icon icon-purchases"></span>
							</p>
							<p className="lead">
								Remove (classname: icon-remove):{' '}
								<span className="icon icon-remove"></span>
							</p>
							<p className="lead">
								TBK (classname: icon-tbk):{' '}
								<span className="icon icon-tbk"></span>
							</p>
							<p className="lead">
								Twitter (classname: icon-twitter):{' '}
								<span className="icon icon-twitter"></span>
							</p>
							<p className="lead">
								YouTube (classname: icon-youtube):{' '}
								<span className="icon icon-youtube"></span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default VHSIconSamples;
